"use strict";

var _regeneratorRuntime = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useController = void 0;

var react_1 = __importStar(require("react"));

var react_modal_1 = __importDefault(require("react-modal"));

var useAnimatedQRCodePlayer_1 = require("./useAnimatedQRCodePlayer");

var useAnimatedQRCodeReader_1 = require("./useAnimatedQRCodeReader");

var customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)'
  }
};

var useController = function useController() {
  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      visible = _react_1$useState2[0],
      setVisible = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState('play'),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      mode = _react_1$useState4[0],
      setMode = _react_1$useState4[1];

  var _useAnimatedQRCodePla = useAnimatedQRCodePlayer_1.useAnimatedQRCodePlayer(),
      _useAnimatedQRCodePla2 = _slicedToArray(_useAnimatedQRCodePla, 2),
      AnimatedQRCodePlayer = _useAnimatedQRCodePla2[0],
      _play = _useAnimatedQRCodePla2[1].play;

  var _useAnimatedQRCodeRea = useAnimatedQRCodeReader_1.useAnimatedQRCodeReader(),
      _useAnimatedQRCodeRea2 = _slicedToArray(_useAnimatedQRCodeRea, 2),
      AnimatedQRCodeReader = _useAnimatedQRCodeRea2[0],
      _read = _useAnimatedQRCodeRea2[1].read;

  var reset = function reset() {
    setVisible(false);
    setMode('play');
  };

  var element = react_1.default.createElement(react_modal_1.default, {
    isOpen: visible,
    style: customStyles
  }, react_1.default.createElement("div", {
    style: {
      width: 320,
      boxSizing: 'border-box',
      padding: 16,
      flex: 1,
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, mode === 'read' ? AnimatedQRCodeReader : AnimatedQRCodePlayer));
  return [element, {
    play: function play(data, options) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setVisible(true);
                setMode('play');
                _context.next = 4;
                return _play(data, options);

              case 4:
                reset();
                return _context.abrupt("return");

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    },
    read: function read(options) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setVisible(true);
                setMode('read');
                _context2.next = 4;
                return _read(options);

              case 4:
                result = _context2.sent;
                reset();
                return _context2.abrupt("return", result);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }];
};

exports.useController = useController;